import React from 'react';
import Loadable from 'react-loadable';
import { Spin } from 'antd';

export default (loader) =>
  Loadable({
    loader,
    loading: () => <Spin />
  });
